import {
  CREATE_APP_RE,
  CREATE_DOC_RE,
  CREATE_SPREADSHEET_RE,
  normalizeArtifactPrompt,
} from './generatedArtifactAssistantPayloadPatterns.js'

/** @returns {'doc' | 'spreadsheet' | 'html' | null} */
export function detectGeneratedArtifactKind(text) {
  const normalized = normalizeArtifactPrompt(text)
  if (CREATE_DOC_RE.test(normalized)) return 'doc'
  if (CREATE_SPREADSHEET_RE.test(normalized)) return 'spreadsheet'
  if (CREATE_APP_RE.test(normalized)) return 'html'
  return null
}

export function isGeneratedArtifactUserMessage(text) {
  return Boolean(detectGeneratedArtifactKind(text))
}
